import { render, staticRenderFns } from "./img_detail.vue?vue&type=template&id=1fbc602a"
import script from "./img_detail.vue?vue&type=script&lang=js"
export * from "./img_detail.vue?vue&type=script&lang=js"
import style0 from "./img_detail.vue?vue&type=style&index=0&id=1fbc602a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports